import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useTheme, type Theme } from '@/lib/theme';

const OPTIONS: ReadonlyArray<{ value: Theme; icon: typeof Sun; labelKey: string }> = [
  { value: 'light', icon: Sun, labelKey: 'theme.light' },
  { value: 'dark', icon: Moon, labelKey: 'theme.dark' },
  { value: 'system', icon: Monitor, labelKey: 'theme.system' },
];

export function ThemeToggle({ showLabels = false }: { showLabels?: boolean }): JSX.Element {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="group"
      aria-label={t('theme.label')}
      className="flex flex-wrap items-center gap-1 rounded-md border border-border p-0.5"
    >
      {OPTIONS.map(({ value, icon: Icon, labelKey }) => (
        <Button
          key={value}
          size="icon"
          variant={theme === value ? 'secondary' : 'ghost'}
          aria-pressed={theme === value}
          aria-label={t(labelKey)}
          title={t(labelKey)}
          className={showLabels ? 'h-11 w-full justify-start px-3 md:h-11 md:w-full' : 'h-7 w-7'}
          onClick={() => setTheme(value)}
        >
          <Icon className="h-5 w-5" aria-hidden="true" />
          {showLabels ? t(labelKey) : null}
        </Button>
      ))}
    </div>
  );
}
